import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeProps as $cE0pI$mergeProps, filterDOMProps as $cE0pI$filterDOMProps, chain as $cE0pI$chain } from "@react-aria/utils";
import { useFocusable as $cE0pI$useFocusable } from "@react-aria/focus";
import { usePress as $cE0pI$usePress } from "@react-aria/interactions";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $701a24aa0da5b062$exports = {};
$parcel$export($701a24aa0da5b062$exports, "useButton", function () {
  return $701a24aa0da5b062$export$ea18c227d4417cc3;
});

function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
  var _props$elementType = props.elementType,
      elementType = _props$elementType === void 0 ? 'button' : _props$elementType,
      isDisabled = props.isDisabled,
      onPress = props.onPress,
      onPressStart = props.onPressStart,
      onPressEnd = props.onPressEnd,
      onPressChange = props.onPressChange,
      // @ts-ignore - undocumented
  preventFocusOnPress = props.preventFocusOnPress,
      // @ts-ignore - undocumented
  allowFocusWhenDisabled = props.allowFocusWhenDisabled,
      deprecatedOnClick = props.onClick,
      href = props.href,
      target = props.target,
      rel = props.rel,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type;
  var additionalProps;
  if (elementType === 'button') additionalProps = {
    type: type,
    disabled: isDisabled
  };else additionalProps = {
    role: 'button',
    tabIndex: isDisabled ? undefined : 0,
    href: elementType === 'a' && isDisabled ? undefined : href,
    target: elementType === 'a' ? target : undefined,
    type: elementType === 'input' ? type : undefined,
    disabled: elementType === 'input' ? isDisabled : undefined,
    'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
    rel: elementType === 'a' ? rel : undefined
  };

  var _$cE0pI$usePress = $cE0pI$usePress({
    onPressStart: onPressStart,
    onPressEnd: onPressEnd,
    onPressChange: onPressChange,
    onPress: onPress,
    isDisabled: isDisabled,
    preventFocusOnPress: preventFocusOnPress,
    ref: ref
  }),
      pressProps = _$cE0pI$usePress.pressProps,
      isPressed = _$cE0pI$usePress.isPressed;

  var _$cE0pI$useFocusable = $cE0pI$useFocusable(props, ref),
      focusableProps = _$cE0pI$useFocusable.focusableProps;

  if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  var buttonProps = $cE0pI$mergeProps(focusableProps, pressProps, $cE0pI$filterDOMProps(props, {
    labelable: true
  }));
  return {
    isPressed: isPressed,
    buttonProps: $cE0pI$mergeProps(additionalProps, buttonProps, {
      'aria-haspopup': props['aria-haspopup'],
      'aria-expanded': props['aria-expanded'],
      'aria-controls': props['aria-controls'],
      'aria-pressed': props['aria-pressed'],
      onClick: function onClick(e) {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn('onClick is deprecated, please use onPress');
        }
      }
    })
  };
}

var $55f54f7887471b58$exports = {};
$parcel$export($55f54f7887471b58$exports, "useToggleButton", function () {
  return $55f54f7887471b58$export$51e84d46ca0bc451;
});

function $55f54f7887471b58$export$51e84d46ca0bc451(props, state, ref) {
  var isSelected = state.isSelected;

  var _$701a24aa0da5b062$ex = $701a24aa0da5b062$export$ea18c227d4417cc3(_objectSpread(_objectSpread({}, props), {}, {
    onPress: $cE0pI$chain(state.toggle, props.onPress)
  }), ref),
      isPressed = _$701a24aa0da5b062$ex.isPressed,
      buttonProps = _$701a24aa0da5b062$ex.buttonProps;

  return {
    isPressed: isPressed,
    buttonProps: $cE0pI$mergeProps(buttonProps, {
      'aria-pressed': isSelected
    })
  };
}

export { $701a24aa0da5b062$export$ea18c227d4417cc3 as useButton, $55f54f7887471b58$export$51e84d46ca0bc451 as useToggleButton };